export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      solutions: 'Solutions',
      track: 'Track',
      contact: 'Contact',
    },
    home: {
      heroTitle: 'Smart delivery across United Arab Emirates',
      heroSubtitle: 'Live tracking link for every shipment',
      trackButton: 'Track existing order',
      scheduleButton: 'Schedule a pickup',
      quickTrack: 'Quick track',
      quickTrackPlaceholder: 'Enter your tracking ID to jump to the status page.',
      trackNow: 'Track now',
      aboutTitle: 'Your Trusted Delivery Partner in UAE',
      aboutDescription: 'At Smart Mile Delivery Services, we revolutionize last-mile delivery across the United Arab Emirates with innovative solutions that connect businesses and communities. Our advanced technology platform seamlessly integrates with your operations, providing real-time visibility and control over every shipment. We understand that every package matters, which is why our experienced team of delivery professionals treats each shipment with the utmost care and attention. From same-day express deliveries to scheduled bulk shipments, we offer flexible solutions that adapt to your unique business needs. Our commitment to excellence extends beyond timely deliveries—we build lasting partnerships by providing exceptional customer service, transparent communication, and reliable support that businesses can count on day after day.',
      whyChooseUs: 'Why Choose Us',
      whyTitle: 'What Makes Smart Mile Different',
      whySubtitle: 'We deliver more than packages—we deliver peace of mind',
      servicesTitle: 'Our Services',
      servicesSubtitle: 'Comprehensive Delivery Solutions',
      howItWorks: 'How It Works',
      howSubtitle: 'Simple Delivery Process',
      testimonials: 'What Our Clients Say',
      getQuote: 'Get a Free Quotation',
      quoteSubtitle: 'Ready to streamline your delivery operations?',
    },
    about: {
      title: 'Delivering Excellence Across UAE',
      subtitle: 'Connecting businesses and communities with reliable, fast, and secure delivery solutions',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive Delivery Solutions',
    },
    solutions: {
      title: 'Solutions',
      subtitle: 'Tailored Solutions for Your Business',
    },
    track: {
      title: 'Track Your Order',
      subtitle: 'Enter your tracking ID to view the status',
      placeholder: 'Enter tracking ID',
      trackButton: 'Track Order',
      errorVoucher: 'Please Enter Your Voucher No',
      errorNotFound: 'Order Not Found',
      errorFailed: 'Failed. Please Try Again Later',
      trackingLabel: 'Tracking...',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send Message',
      errorName: 'Please Enter Your Name',
      errorMobile: 'Please Enter Your Mobile No',
      errorEmail: 'Please Enter Your Email Id',
      errorSubject: 'Please Enter Subject',
      errorMessage: 'Please Enter Your Message',
      errorFailed: 'Failed. Please Try Again Later',
      successMessage: 'Successfully Sent Your Enquiry. We Will Reach You Soon.',
    },
    footer: {
      description: 'Reliable, fast, and secure delivery services tailored for businesses and individuals across the UAE.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      rights: 'All rights reserved.',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      solutions: 'الحلول',
      track: 'تتبع',
      contact: 'اتصل بنا',
    },
    home: {
      heroTitle: 'توصيل ذكي عبر دولة الإمارات العربية المتحدة',
      heroSubtitle: 'رابط تتبع مباشر لكل شحنة',
      trackButton: 'تتبع الطلب الحالي',
      scheduleButton: 'جدولة استلام',
      quickTrack: 'تتبع سريع',
      quickTrackPlaceholder: 'أدخل معرف التتبع للانتقال إلى صفحة الحالة.',
      trackNow: 'تتبع الآن',
      aboutTitle: 'شريك التوصيل الموثوق في الإمارات',
      aboutDescription: 'في خدمات توصيل سمارت مايل، نحدث ثورة في التوصيل من الباب إلى الباب عبر دولة الإمارات العربية المتحدة من خلال حلول مبتكرة تربط الشركات والمجتمعات. تدمج منصتنا التكنولوجية المتقدمة بسلاسة مع عملياتك، مما يوفر رؤية وتحكم في الوقت الفعلي لكل شحنة. نحن ندرك أن كل طرد مهم، ولهذا السبب يعامل فريقنا المتمرس من محترفي التوصيل كل شحنة بأقصى قدر من العناية والاهتمام. من التوصيلات السريعة في نفس اليوم إلى الشحنات المجدولة بالجملة، نقدم حلولاً مرنة تتكيف مع احتياجات عملك الفريدة. يمتد التزامنا بالتميز إلى ما هو أبعد من التوصيلات في الوقت المحدد—نبني شراكات دائمة من خلال تقديم خدمة عملاء استثنائية وتواصل شفاف ودعم موثوق يمكن للشركات الاعتماد عليه يوماً بعد يوم.',
      whyChooseUs: 'لماذا تختارنا',
      whyTitle: 'ما الذي يجعل سمارت مايل مختلفاً',
      whySubtitle: 'نحن لا نقدم الطرود فقط—نقدم راحة البال',
      servicesTitle: 'خدماتنا',
      servicesSubtitle: 'حلول توصيل شاملة',
      howItWorks: 'كيف يعمل',
      howSubtitle: 'عملية توصيل بسيطة',
      testimonials: 'ماذا يقول عملاؤنا',
      getQuote: 'احصل على عرض أسعار مجاني',
      quoteSubtitle: 'هل أنت مستعد لتبسيط عمليات التوصيل الخاصة بك؟',
    },
    about: {
      title: 'تقديم التميز عبر الإمارات',
      subtitle: 'ربط الشركات والمجتمعات بحلول توصيل موثوقة وسريعة وآمنة',
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول توصيل شاملة',
    },
    solutions: {
      title: 'الحلول',
      subtitle: 'حلول مخصصة لعملك',
    },
    track: {
      title: 'تتبع طلبك',
      subtitle: 'أدخل معرف التتبع لعرض الحالة',
      placeholder: 'أدخل معرف التتبع',
      trackButton: 'تتبع الطلب',
      errorVoucher: 'يرجى إدخال رقم القسيمة الخاص بك',
      errorNotFound: 'الطلب غير موجود',
      errorFailed: 'فشل. يرجى المحاولة مرة أخرى لاحقاً',
      trackingLabel: 'جاري التتبع...',
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      message: 'الرسالة',
      send: 'إرسال الرسالة',
      errorName: 'يرجى إدخال اسمك',
      errorMobile: 'يرجى إدخال رقم هاتفك المحمول',
      errorEmail: 'يرجى إدخال بريدك الإلكتروني',
      errorSubject: 'يرجى إدخال الموضوع',
      errorMessage: 'يرجى إدخال رسالتك',
      errorFailed: 'فشل. يرجى المحاولة مرة أخرى لاحقاً',
      successMessage: 'تم إرسال استفسارك بنجاح. سنتواصل معك قريباً.',
    },
    footer: {
      description: 'خدمات توصيل موثوقة وسريعة وآمنة مصممة للشركات والأفراد في جميع أنحاء الإمارات.',
      quickLinks: 'روابط سريعة',
      contact: 'اتصل',
      legal: 'قانوني',
      privacy: 'سياسة الخصوصية',
      terms: 'الشروط والأحكام',
      rights: 'جميع الحقوق محفوظة.',
    },
  },
}
